// 安全存储工具：使用 AES 对本地存储的 token 进行加密/解密
// 注意：仅用于浏览器侧提升安全性，不能替代后端安全控制

import CryptoJS from 'crypto-js';

// 加密密钥从环境变量读取，避免硬编码；开发环境下提供回退值
const SECRET = import.meta.env.VITE_TOKEN_SECRET || 'dev_fallback_secret_key';
const TOKEN_KEY = 'auth_token_secure';

/**
 * 加密并存储 token
 */
export const setSecureToken = (token: string): boolean => {
  try {
    if (typeof window === 'undefined' || !token) return false; // 非浏览器或空 token 直接返回
    // 使用 AES 加密 token
    const cipherText = CryptoJS.AES.encrypt(token, SECRET).toString();
    localStorage.setItem(TOKEN_KEY, cipherText);
    return true;
  } catch (error) {
    console.warn('setSecureToken failed:', error);
    return false;
  }
};

/**
 * 解密并获取 token
 */
export const getSecureToken = (): string | null => {
  try {
    if (typeof window === 'undefined') return null;
    const cipherText = localStorage.getItem(TOKEN_KEY);
    if (!cipherText) return null;
    // 解密为明文
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET);
    const plain = bytes.toString(CryptoJS.enc.Utf8);
    return plain || null; // 解密失败时返回 null
  } catch (error) {
    console.warn('getSecureToken failed:', error);
    return null;
  }
};

/**
 * 清除加密存储的 token
 */
export const clearSecureToken = (): boolean => {
  try {
    if (typeof window === 'undefined') return false;
    localStorage.removeItem(TOKEN_KEY);
    return true;
  } catch (error) {
    console.warn('clearSecureToken failed:', error);
    return false;
  }
};